<template>
  <div class="solution">
    <umf-header style="position: absolute;" @changeId="changeId"></umf-header>
    <div class="banner">
      <div class="row">
        <h4>
          <img src="~images/solution/finance/banner-text.png"
               alt="">
        </h4>
        <p>鑫毅数科数字化行业解决方案， </p>
        <p>以技术创新服务金融和实体产业，</p>
        <p>助力各行业数字转型、智能升级、融合创新。</p>
      </div>
    </div>

    <div class="nav-box clearfix">
      <div class="row">
        <ul>
          <li :class="{active: id == 0}" @click="btnLi(0)">决策引擎解决方案</li>
          <li :class="{active: id == 1}" @click="btnLi(1)">自动化建模解决方案</li>
          <li :class="{active: id == 2}" @click="btnLi(2)">智能风控解决方案</li>
          <li :class="{active: id == 3}" @click="btnLi(3)">智慧营销解决方案</li>
        </ul>
      </div>
    </div>
    <div class="page">
      <div class="page-box" style="display:block;" v-if="id == 0">
        <div class="page-one">
          <div class="row">
            <h3>方案简介</h3>
            <div class="center-bg bg1">
              <div class="text-box">
                <h4>决策引擎解决方案</h4>
                <p>鑫毅数科决策引擎解决方案结合风险理论和数据中台能力，精准部署数据维度，分析基础数据、风险因子等，帮助金融客户创建、管理风控策略，配置并执行风控策略，实现决策规范化、标准化、自动化，并建立起科学的反馈机制，通过不断优化保证业务的持续增长，并降低成本与风险。 </p>
              </div>
            </div>
          </div>
        </div>
        <div class="page-two">
          <div class="row">
            <h3>方案优势</h3>
            <div class="center-box bg2">
              <div class="ulList">
                <div class="ulListBox">
                  <div class="left">
                    <img src="~images/solution/icon1.png" alt="">
                    <p>全部自主开发，非包装开源产品，自主性强，支持定制开发 </p>
                  </div>
                  <div class="right">
                    <img src="~images/solution/icon1.png" alt="">
                    <p>B-S架构，Web Service接口，易于实施</p>
                  </div>
                </div>
                
                <div class="ulListBox">
                  <div class="left">
                    <img src="~images/solution/icon1.png" alt="">
                    <p>面向业务客户使用，无需IT基础即可完成所有配置</p>
                  </div>
                </div>
                
              </div>
              <!-- <ul>
                <li>
                  <img src="~images/solution/icon1.png"
                       alt="">
                  <p></p>
                </li>

                <li>
                  <img src="~images/solution/icon1.png"
                       alt="">
                  <p></p>
                </li>
                <li>
                  <img src="~images/solution/icon1.png"
                       alt="">
                  <p>面向业务客户使用，无需IT基础即可完成所有配置</p>
                </li>
              </ul> -->
            </div>
          </div>
        </div>
      </div>

      <div class="page-box" style="display:block;" v-if="id == 1">
        <div class="page-one">
          <div class="row">
            <h3>方案简介</h3>
            <div class="center-bg bg2">
              <div class="text-box">
                <h4>自动化建模解决方案</h4>
                <p>利用区块链、数据科技和人工智能技术，保证业务数据安全可控的前提下，在数千项信息维度的基础上，建立金融机构专属的风控模型，从不同角度洞察和评价用户，帮助信贷机构有限把控风险。</p>
              </div>
            </div>
          </div>
        </div>
        <div class="page-two">
          <div class="row">
            <h3>方案优势</h3>
            <div class="center-box">
              <div class="ulList">
                <div class="ulListBox">
                  <div class="left">
                    <img src="~images/solution/icon1.png" alt="">
                    <p>智能化样本分析，自动进行数据监测 </p>
                  </div>
                  <div class="right">
                    <img src="~images/solution/icon1.png" alt="">
                    <p>图形化建模过程，最大化简便操作</p>
                  </div>
                </div>
                
                <div class="ulListBox">
                  <div class="left">
                    <img src="~images/solution/icon1.png" alt="">
                    <p>内置机器学习常用算法库，个性化编写算法脚本</p>
                  </div>
                  <div class="right">
                    <img src="~images/solution/icon1.png" alt="">
                    <p>支持系统自动设置最佳参数，支持手动调参</p>
                  </div>
                </div>
                
              </div>
              <!-- <ul>
                <li>
                  <img src="~images/solution/icon1.png"
                       alt="">
                  <p>智能化样本分析，自动进行数据监测 </p>
                </li>
                <li>
                  <img src="~images/solution/icon1.png"
                       alt="">
                  <p>图形化建模过程，最大化简便操作 </p>
                </li>
                <li>
                  <img src="~images/solution/icon1.png"
                       alt="">
                  <p>内置机器学习常用算法库，个性化编写算法脚本 </p>
                </li>

                <li>
                  <img src="~images/solution/icon1.png"
                       alt="">
                  <p>支持系统自动设置最佳参数，支持手动调参 </p>
                </li>
              </ul> -->
            </div>
          </div>
        </div>
      </div>

      <div class="page-box" style="display:block;" v-if="id == 2">
        <div class="page-one">
          <div class="row">
            <h3>方案简介</h3>
            <div class="center-bg bg3">
              <div class="text-box">
                <h4>智能风控解决方案</h4>
                <p>借助数据技术和人工智能技术，基于不同业务场景的数据管理，通过科学分析和各类模型工具，挖掘场景数据所蕴含的真正价值，协助持牌金融机构覆盖贷前、贷中、贷后全风控流程，提升其风险管理能力，解决互联网金融时代持牌机构在零售信贷领域的核心挑战。</p>
              </div>
            </div>
          </div>
        </div>
        <div class="page-two">
          <div class="row">
            <h3>方案优势</h3>
            <div class="center-box">
              <ul>
                <li>
                  <img src="~images/solution/icon1.png"
                       alt="">
                  <p>标准化通用评分支持新业务快速启动 </p>
                </li>
                <li>
                  <img src="~images/solution/icon1.png"
                       alt="">
                  <p>可定制的模型实验室服务，提供近万维兼具效果与可解释性的特征变量池 </p>
                </li>

              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="page-box" style="display:block;" v-if="id == 3">
        <div class="page-one">
          <div class="row">
            <h3>方案简介</h3>
            <div class="center-bg">
              <div class="text-box">
                <h4>助贷平台解决方案</h4>
                <p>基于鑫毅数科的技术积累，围绕银行数字化转型需求，通过与消费场景共享数据、算法、交易、流程和其他业务功能，搭建金融与场景的连接桥梁，推动银行的业务触角向消费场景延伸，挖掘消费场景的金融需求，帮助银行实现从粗放式经营到精细化管理的快速转型。</p>
              </div>
            </div>
          </div>
        </div>
        <div class="page-two">
          <div class="row">
            <h3>方案优势</h3>
            <div class="center-box">
              <ul>
                <li>
                  <img src="~images/solution/icon1.png"
                       alt="">
                  <p>全面建设信贷产品、渠道运营和大数据风控体系 </p>
                </li>
                <li>
                  <img src="~images/solution/icon1.png"
                       alt="">
                  <p>共享鑫毅数科商务资源和运营经验 </p>
                </li>
                <li>
                  <img src="~images/solution/icon1.png"
                       alt="">
                  <p>为银行撮合高质量资产，优化资产配置 </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div> -->

      <div class="page-box" style="display:block;" v-if="id == 3">
        <div class="page-one">
          <div class="row">
            <h3>方案简介</h3>
            <div class="center-bg bg4">
              <div class="text-box">
                <h4>智慧营销解决方案</h4>
                <p>从营销获客，到基础运营平台，再升级到智能运营平台，持续迭代升级，提供金融机构产品各个营销阶段的用户营销、用户运营服务。</p>
              </div>
            </div>
          </div>
        </div>
        <div class="page-two">
          <div class="row">
            <h3>方案优势</h3>
            <div class="center-box">
              <div class="ulList">
                <div class="ulListBox">
                  <div class="left">
                    <img src="~images/solution/icon1.png" alt="">
                    <p>获客成本低于市场50 </p>
                  </div>
                  <div class="right">
                    <img src="~images/solution/icon1.png" alt="">
                    <p>用户留存90%，高于市场平均值20</p>
                  </div>
                </div>
                <div class="ulListBox">
                  <div class="left">
                    <img src="~images/solution/icon1.png" alt="">
                    <p>品牌权益场景深度合作 </p>
                  </div>
                </div>
              </div>
              
              <!-- <ul>
                <li>
                  <img src="~images/solution/icon1.png"
                       alt="">
                  <p>获客成本低于市场50% </p>
                </li>
                <li>
                  <img src="~images/solution/icon1.png"
                       alt="">
                  <p>用户留存90%，高于市场平均值20% </p>
                </li>
                <li>
                  <img src="~images/solution/icon1.png"
                       alt="">
                  <p>品牌权益场景深度合作 </p>
                </li>
              </ul> -->
            </div>
          </div>
        </div>
      </div>

    </div>
    <umf-footer :topBanner='1'></umf-footer>
  </div>
</template>

<script>
import UmfHeader from '@/components/umfHeader'
import umfFooter from '@/components/umfFooter'
import $ from 'jquery'
export default {
  components: {
    UmfHeader,
    umfFooter
  },

  computed: {

  },
  data () {
    return {
      id: 0
    }
  },
  created () {
   
  },
  mounted () {
    if(this.$route.query.id) {

      this.id = this.$route.query.id
    }
     
    /* if (this.id) {
      $('.page .page-box').eq(this.id).fadeIn().siblings().fadeOut()
      $('.nav-box ul li').eq(this.id).addClass('active').siblings().removeClass('active')
    } */
    let _this = this
   /*  $('.nav-box ul li').on('click', function () {
      $(this).addClass('active').siblings().removeClass('active')
      let index = $(this).index()
      $('.page .page-box').eq(index).fadeIn().siblings().fadeOut()
    }) */
  },
  methods: {
    changeId(id) {
      
      this.id = id
    },
    btnLi(id) {
      this.id = id
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/solution/solution.scss";

.solution {
  .banner {
    background-image: url(~images/solution/finance/banner.png);
  }
  .nav-box {
    ul {
      li {
        box-sizing: border-box;
        width: 20%;
      }
    }
  }
  .page {
    .page-box {
      &:nth-child(1) {
        .center-bg {
          background-image: url(~images/solution//finance/center-bg1.png);
        }
      }
      &:nth-child(2) {
        .center-bg {
          background-image: url(~images/solution//finance/center-bg2.png);
        }
      }
      &:nth-child(3) {
        .center-bg {
          background-image: url(~images/solution//finance/center-bg3.png);
        }
      }
      &:nth-child(4) {
        .center-bg {
          background-image: url(~images/solution//finance/center-bg4.png);
        }
      }
      &:nth-child(5) {
        .center-bg {
          background-image: url(~images/solution//finance/center-bg5.png);
        }
      }
    }
  }
}

      .bg1 {
        background-image: url(~images/solution//finance/center-bg1.png) !important;
      }
      .bg2 {
        background-image: url(~images/solution//finance/center-bg2.png) !important;
      }
      .bg3 {
        background-image: url(~images/solution//finance/center-bg3.png) !important;
      }
      .bg4 {
        background-image: url(~images/solution//finance/center-bg4.png) !important;
      }
.ulList {
  width: 1200px;
  .ulListBox {
    width: 1200px;
    height: 40px;
    background: #efeff3;
    border: 1px solid #e1e2e6;
    padding: 20px 50px;
    .left {
      width: 600px;
      height: 40px;
      display: inline-block;
      img {
        float: left;
      }
      p {
        float: left;
        line-height: 40px;
        color: #515259;
        font-size: 18px;
        padding-left: 45px;
      }
    }
    .right {
      width: 50%;
      height: 40px;
      display: inline-block;
      img {
        float: left;
      }
      p {
        float: left;
        line-height: 40px;
        color: #515259;
        font-size: 18px;
        padding-left: 45px;
      }
    }
  }
}
</style>

